import { Tooltip, IconButton } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateLeft } from '@fortawesome/pro-regular-svg-icons';

interface IUndoEdit {
  onUndo?: () => void;
  id?: string;
  size?: 'sm' | 'md' | 'lg';
}

const UndoEdit = (props: IUndoEdit) => {
  const { id, onUndo, size } = props;

  const undoLabel = 'Undo edit';

  return (
    <Tooltip hasArrow label={undoLabel} placement="top">
      <IconButton
        aria-label={undoLabel}
        size={size || 'lg'}
        data-selector={`${id}-undo`}
        onClick={onUndo}
        icon={<FontAwesomeIcon icon={faArrowRotateLeft} />}
      />
    </Tooltip>
  );
};

export { UndoEdit };
